import { pgTable, serial, text, integer, numeric, timestamp, jsonb } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const companiesTable = pgTable("companies", {
  id: serial("id").primaryKey(),
  name: text("name").notNull(),
  sector: text("sector"),
  targetRegions: jsonb("target_regions").$type<string[]>().notNull().default([]),
  experience: text("experience"),
  certifications: jsonb("certifications").$type<string[]>().notNull().default([]),
  minProjectValue: numeric("min_project_value", { precision: 15, scale: 2 }),
  maxProjectValue: numeric("max_project_value", { precision: 15, scale: 2 }),
  preferredProjectTypes: jsonb("preferred_project_types").$type<string[]>().notNull().default([]),
  bio: text("bio"),
  logoUrl: text("logo_url"),
  minBidScore: integer("min_bid_score").notNull().default(60),
  analysisUsedThisMonth: integer("analysis_used_this_month").notNull().default(0),
  analysisResetAt: timestamp("analysis_reset_at").notNull().defaultNow(),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertCompanySchema = createInsertSchema(companiesTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertCompany = z.infer<typeof insertCompanySchema>;
export type Company = typeof companiesTable.$inferSelect;
